import React, { useEffect } from 'react';

export const VideoSection = () => {
  useEffect(() => {
    // Load the SmartPlayer script
    const existingScript = document.querySelector('script[src*="converteai.net/lib/js/smartplayer"]');
    if (!existingScript) {
      const script = document.createElement('script');
      script.src = 'https://scripts.converteai.net/lib/js/smartplayer-wc/v4/sdk.js';
      script.async = true;
      document.head.appendChild(script);
    }
  }, []);

  const videoEmbedHTML = `
    <div id="ifr_698e3f4dceb26906d003b07e_wrapper" style="margin: 0 auto; width: 100%;">
      <div style="position: relative; padding: 56.25% 0 0 0;" id="ifr_698e3f4dceb26906d003b07e_aspect">
        <iframe 
          frameborder="0" 
          allowfullscreen 
          src="https://scripts.converteai.net/a5d4194b-bd13-448e-a24d-a7c1aacfe7d4/players/698e3f4dceb26906d003b07e/v4/embed.html"
          id="ifr_698e3f4dceb26906d003b07e" 
          style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; border-radius: 12px;"
          referrerpolicy="origin"
        ></iframe>
      </div>
    </div>
  `;

  return (
    <section className="bg-gradient-to-b from-gray-900 to-black py-16 md:py-24">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-10">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-white mb-4">
            Descubrí el camino de la Cábala
          </h2>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto">
            Mirá este video para entender cómo este libro puede transformar tu vida
          </p>
        </div>

        {/* Video Player */}
        <div 
          className="max-w-4xl mx-auto"
          dangerouslySetInnerHTML={{ __html: videoEmbedHTML }}
        />

        {/* CTA below video */}
        <div className="text-center mt-10">
          <p className="text-amber-400 text-lg font-medium mb-4">
            ¿Listo para empezar tu viaje?
          </p>
          <a 
            href="/reader/register"
            className="inline-flex items-center gap-2 bg-gradient-to-r from-amber-500 to-orange-500 hover:from-amber-600 hover:to-orange-600 text-white px-8 py-4 rounded-full font-semibold text-lg transition-all transform hover:scale-105 shadow-lg shadow-amber-500/30"
          >
            Empezar a leer gratis
          </a>
        </div>
      </div>
    </section>
  );
};

export default VideoSection;
